// Переводы статусов и приоритетов задач на русский язык

export const TASK_PRIORITY = {
  low: 'Низкий',
  medium: 'Средний',
  high: 'Высокий',
};

// Функция для получения русского названия приоритета
export const getPriorityLabel = (priority) => {
  return TASK_PRIORITY[priority] || priority;
};

// Функция для получения иконки приоритета
export const getPriorityIcon = (priority) => {
  const icons = {
    low: '🟢',
    medium: '🟡',
    high: '🔴',
  };
  return icons[priority] || '⚪';
};
